import React from 'react';
import BaseErrorBoundary from '../BaseErrorBoundary';
import RootErrorFallback from './RootErrorFallback';

const RootErrorBoundary = (props) => {
  return (
    <BaseErrorBoundary
      errorFallbackComponent={RootErrorFallback}
      errorIdPrefix="ERR_"
      reportType="Error Report"
      {...props}
    />
  );
};

export default RootErrorBoundary;
